module.exports = __webpack_public_path__ + "img/04—01—01—Settings > Inline Edit.84979940.jpg";